import { render } from "./EnrichTicketInfo.vue?vue&type=template&id=88711276"
import script from "./EnrichTicketInfo.vue?vue&type=script&lang=js"
export * from "./EnrichTicketInfo.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2419941712/src/fantini-forms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__